import request from '@/utils/request'
import { getToken, isEmulation } from '@/utils/auth'

export function getList (entity, filters = {}, pagination = {}) {
  //issue 242 services
  if (entity === 'log')
  {
    filters["response"] = "%{%"
  }
  //issue 242 services

  //issue 148
  for(var t in filters)
  {
    if (t.indexOf("_$$$_from") > -1)
    {
      var oldval1 = filters[t]
      filters[t] = {}
      filters[t][t.split('_$$$_from')[0]] = '>='+ oldval1
    }
    if (t.indexOf("_$$$_to") > -1)
    {
      var oldval2 = filters[t]
      filters[t] = {}
      filters[t][t.split('_$$$_to')[0]] = '<='+ oldval2
    }
  }
  //issue 148
    
  return request({
    url: '/' + entity,
    method: 'get',
    headers: {
      'x-filters': JSON.stringify(filters),
      'x-pagination': JSON.stringify(pagination)
    }
  }).then( ret => { ret.data = ret.data.map( el => { el._exists = true; return el} ); return ret } )
}

export function getCount (entity, filters = {}) {
  //issue 242 services
  if (entity === 'log')
  {
    filters["response"] = "%{%"
  }
  //issue 242 services

  return request({
    url: '/' + entity,
    method: 'get',
    headers: {
      'x-filters': JSON.stringify(filters),
      'x-pagination': JSON.stringify({ rowsPerPage: 1 })
    }
  }).then(ret => ret.tot)
}

export function getDetail (entity, entity_id, headers) {
  return request({
    url: '/' + entity + '/' + entity_id,
    method: 'get',
    headers
  }).then( ret => { ret._exists = true; ret._entity_id = entity_id; return ret })
}

export function get (url) {
  return request({
    url,
    method: 'get',
  })
}

export function post (url, data) {
  request.defaults.timeout = 50000;
  return request({
    url,
    method: 'post',
    data
  })
}


export function put (entity, id, data) {
  const method = 'put'
  const url = '/' + entity + '/' + id
  return request({
    url,
    method,
    data
  })
}

export function upsert (entity, data) {
  request.defaults.timeout = 50000;
  let method = 'post'
  let url = '/' + entity
  if (data.id) {
    method = 'put'
    url = '/' + entity + '/' + data.id
  }
  return request({
    url,
    method,
    data
  })
}

export function remove (entity, item) {
  return request({
    url: '/' + entity + '/' + item.id,
    method: 'delete'
  })
}



export function download(path, file = 'file', filters = null) {

  return fetch(
    process.env.VUE_APP_BASE_API + `/${path}`,
    {
      headers: {
        Authorization: 'Bearer ' + getToken(),
        isEmulation: isEmulation() || '',
        'x-filters': JSON.stringify(filters)
      },
      responseType: 'blob'     
    }
  )
  .then( response => {
    
    const filename = response.headers.get("X-Filename") || file

    response.blob().then( blob => {
      var fileURL = window.URL.createObjectURL(blob);
      var fileLink = document.createElement('a');
      fileLink.href = fileURL;
      fileLink.setAttribute('download', filename);
      document.body.appendChild(fileLink);
      fileLink.click();
    })
  })
  
}


export function uploadPdf (data, type) {

  request.defaults.timeout = 20000;
  const promise = request({
    url: '/pdf/upload/' + type,
    method: 'post',
    data,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
  promise.finally( () => { request.defaults.timeout = 50000;})
  return promise;
}